import React from "react";
import { Hyperlink } from "src/components";
import globalTheme, { media } from "src/theme";
import styled from "styled-components";

import { IPageType, ITheme } from "../types";

const Name = styled.div<ITheme & IPageType>`
  margin: 0;
  font-weight: 700;
  font-family: ${globalTheme.fonts.granville};

  font-size: ${({ theme }: ITheme): string =>
    theme === "mini"
      ? globalTheme.fontSizes.regular
      : globalTheme.fontSizes.title};

  line-height: 1.3;
  letter-spacing: 1.5px;
  padding: ${({ theme }: ITheme): string =>
    theme === "mini" || theme === "newArrivals" ? "0" : "0 25px"};

  /* PRODUCT */
  ${({ pageType }: IPageType): string | false =>
    pageType === "product" &&
    `
      font-family: ${globalTheme.fonts.granville};
    `}
 
  /* CATEGORY & SEARCH */
  ${({ pageType }: IPageType): string | false =>
    (pageType === "category" || pageType === "productSearch") &&
    `
      min-height: 45px;
      padding: 0;
      font-family: ${globalTheme.fonts.granville};
      font-size: ${globalTheme.fontSizes.regular};
      font-weight: 400;
      letter-spacing: 0;
      display: flex;
      align-items: flex-start;
    `}


  ${media.mobile} {
    /* PRODUCT */
    ${({ pageType }: IPageType): string | false =>
      pageType === "product" &&
      `
        padding: 0;
        font-size: ${globalTheme.fontSizes.huge};
      `}
  }
  ${media.tablet} {
    /* PRODUCT */
    ${({ pageType }: IPageType): string | false =>
      pageType === "product" &&
      `
        text-align: left;
      `}
  }
`;

interface IProps extends IPageType, ITheme {
  hasNoProductLink: boolean | undefined;
  url: string | undefined;
  name: string;
}

const ProductTitle = ({
  hasNoProductLink,
  url,
  name,
  pageType,
  theme,
}: IProps): JSX.Element | null => {
  const tag =
    pageType === "product"
      ? "h1"
      : pageType === "category"
      ? "h2"
      : pageType === "productSearch"
      ? "div"
      : "h3";

  if (!hasNoProductLink && !!url) {
    return (
      <Hyperlink className="product-name-link" to={url}>
        <Name
          as={tag}
          className="product-name"
          theme={theme}
          pageType={pageType}
        >
          {name}
        </Name>
      </Hyperlink>
    );
  }

  return (
    <Name as={tag} className="product-name" theme={theme} pageType={pageType}>
      {name}
    </Name>
  );
};

export default ProductTitle;
